<div class="tank-transfer">
  <div class="reorder">
    <re-reorder-buttons (reorder)="onReorder($event)" />
  </div>
  <div class="delete">
    <re-trash-button (delete)="onDelete()" />
  </div>
  <h2 class="transfer-header text-center">Tank Transfer</h2>
  <div class="container">
    <div class="from-tank tank">
      <re-tank-summary
        [tank]="from"
        [progress]="fromProgress"
        [progress2]="progress2"
        [tankNumber]="from.number"
        [tankName]="from.name"
        [fuelGrade]="'HFO'"
        [quantity]="from.content!.quantity - transferAmount"
      />
    </div>

    <div class="transfer-amount">
      <div>
        <div class="arrow">
          <nsp-icon [name]="IconNames.ArrowRight" />
        </div>
        <input
          (input)="onInputChange()"
          (ngModelChange)="onModelChange()"
          [(ngModel)]="transferAmount"
          [max]="maxTransferAmount"
          [min]="0"
          type="number"
          name="transfer-amount"
          placeholder="0"
        />
        MT

        <div class="swap">
          <button
            class="mb-4 rounded-sm bg-indigo-700 px-1"
            (click)="onSwapTanks()"
          >
            Swap Tanks
          </button>
        </div>
      </div>
    </div>

    <div class="to-tank tank">
      <re-tank-summary
        [tank]="to"
        [progress]="toProgress"
        [progress2]="progress3"
        [tankNumber]="to.number"
        [tankName]="to.name"
        [fuelGrade]="'HFO'"
        [quantity]="to.content!.quantity + transferAmount"
      />
    </div>
  </div>
</div>
